import React from 'react';

// import { Container } from './styles';

const Production: React.FC = () => {
  return <div>Production</div>;
};

export default Production;
